import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { formatInputDate } from "../../utils/Time";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import { formatSplitKey } from "../../commons/FormatValue";
import { getServiceRequest } from "../../commons/ServiceRequest";
import { FloatingControlComponent } from "../../components/FormComponent";
import {
  filteredCreateNewKey,
  findItemBySearch,
  findItemInArray
} from "../../utils/ManageArray";
import Table from "../../components/Table";
import ButtonLink from "../../components/ButtonLink";
import SearchFilter from "../../components/SearchFilter";
import CardDisplayComponent from "../../components/CardDisplayComponent";
import BillOfReqDtService from "../../services/billofreqdt.service";
import BillOfReqHdService from "../../services/billofreqhd.service";

export default function SearchRequest() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { loading, setLoading } = useLoading(false);
  const [checkType, setCheckType] = useState(true);
  const [BillOfReqHd, setBillOfReqHd] = useState([]);
  const [BillOfReqDt, setBillOfReqDt] = useState([]);
  const [searchValue, setSearchValue] = useState([]);
  const [searchInput, setSearchInput] = useState([
    {
      name: "Job_Type_Name",
      label: "ประเภทงาน",
      noneAsync: true,
      filterBy: ["Job_Type_Name"]
    },
    {
      name: "Bill_Doc_No",
      label: "เลขที่ใบขอเบิก",
      filterBy: ["Bill_Doc_No"]
    }
  ]);

  const handleSearchFilter = (search) => {
    const shouldClearState = search.some(({ value }) => value);
    const newSearch = shouldClearState
      ? filteredCreateNewKey({
          data: BillOfReqHd,
          search,
          newName: "Bill_Of_Hd_Id",
          newValue: "Id"
        })
      : [];
    const findedData = findItemInArray(search, "name", "Job_Type_Name");
    setSearchValue(shouldClearState ? newSearch : []);
    setCheckType(
      shouldClearState
        ? ["PM", "ติดตั้ง", "แจ้งซ่อม"].includes(findedData?.value)
        : true
    );

    if (!shouldClearState && state?.Bill_Of_Hd_Id) {
      navigate("/reimbursement_refund/", { state: { name: "data" } });
      setSearchInput(searchInput.map((input) => ({ ...input, value: null })));
    }
  };

  useEffect(() => {
    if (BillOfReqHd?.length === 0 && BillOfReqDt?.length === 0) {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: BillOfReqDtService.getAllBillOfReqDts(),
        callback: (res) => setBillOfReqDt(res)
      });
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: BillOfReqHdService.getAllBillOfReqHds(),
        callback: (res) => setBillOfReqHd(res)
      });
    } else if (
      BillOfReqHd?.length > 0 &&
      searchValue?.length === 0 &&
      state?.Bill_Of_Hd_Id
    ) {
      const updatedInput = searchInput.map((input) => ({
        ...input,
        value: formatSplitKey(
          input?.name,
          ".",
          findItemInArray(BillOfReqHd, "Id", state?.Bill_Of_Hd_Id)
        )
      }));
      setSearchInput(updatedInput);
      handleSearchFilter(updatedInput);
    }
  }, [BillOfReqHd, BillOfReqDt, searchValue]);

  return (
    <>
      <CardDisplayComponent
        header={{
          title: {
            className: "text-center",
            text: "ค้นหาประเภทงานและเลขที่ใบขอเบิก"
          }
        }}
        body={{
          element: (
            <SearchFilter
              data={BillOfReqHd}
              inputField={searchInput}
              fieldClassName={{ actionButton: "w-auto py-2" }}
              searchBtnOnClick={searchInput.some(({ value }) => value)}
              searchCallback={handleSearchFilter}
            />
          )
        }}
      />

      <CardDisplayComponent
        body={{
          className: "d-flex justify-content-center",
          element: [
            { label: "แสดงใบขอเบิกรวมยอดทุกเครื่อง", type: "Request_All" },
            { label: "แสดงใบขอเบิกสรุปรายการตามเครื่อง", type: "Item_By" },
            { label: "แสดงใบขอเบิกแยกตามเครื่อง", type: "Separated_By" },
            { label: "แสดงใบขอเบิกงานขายและอื่นๆ", type: "Others_By" }
          ].map(({ label, type }, idx) => (
            <ButtonLink
              key={idx}
              linkTo="preview"
              buttonName={label}
              buttonClass="ms-1 me-3 px-4 py-2 border-opacity-50 rounded-pill"
              stateData={{ name:"data",label ,type }}
              isDisabled={searchValue?.length > 0}
            />
          ))
        }}
      />

    </>
  );
}
